import { AcknowledgmentData } from '../components/AcknowledgmentStatusAlerts';

/**
 * Gets the most recent acknowledgment time from a list of acknowledgments
 *
 * @param acknowledgements - Array of acknowledgment data
 * @returns Formatted timestamp of the latest acknowledgment or 'N/A' if none
 */
export const getLatestAcknowledgmentTime = (
  acknowledgements: AcknowledgmentData[]
): string => {
  const latestAck = acknowledgements
    .filter((ack) => ack.acknowledgedAt)
    .sort((a, b) => {
      const aTime = a.acknowledgedAt ? new Date(a.acknowledgedAt).getTime() : 0;
      const bTime = b.acknowledgedAt ? new Date(b.acknowledgedAt).getTime() : 0;
      return bTime - aTime;
    })[0];

  return latestAck?.acknowledgedAt
    ? new Date(latestAck.acknowledgedAt).toLocaleString()
    : 'N/A';
};

/**
 * Calculates acknowledgment statistics from a list of acknowledgments
 *
 * @param acknowledgements - Array of acknowledgment data
 * @returns Object containing counts of acknowledged, pending, and total
 *   acknowledgments
 */
export const getAcknowledgmentCounts = (
  acknowledgements: AcknowledgmentData[]
) => {
  const acknowledgedCount = acknowledgements.filter(
    (ack) => ack.acknowledgedAt
  ).length;
  const pendingCount = acknowledgements.filter(
    (ack) => !ack.acknowledgedAt
  ).length;
  const totalCount = acknowledgements.length;

  return {
    acknowledgedCount,
    pendingCount,
    totalCount,
  };
};
